<script lang="ts" setup>
defineProps<{
  plainHtml: string
}>()
</script>

<template>
  <div class="html-area" v-html="plainHtml" />
</template>

<style lang="scss" scoped>
.html-area {
  $lineHeight: 1.25em;

  line-height: $lineHeight;
  max-height: 99999px;
  overflow: hidden;
  word-wrap: break-word;

  :deep(ol),
  :deep(ul) {
    margin-top: 1em;
    overflow: hidden; // For floating element (e.g. picture).

    & > li:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  :deep(ol) {
    padding: revert;

    & > li {
      margin-left: 0;
      padding-left: .75em;
    }
  }

  :deep(table),
  :deep(ol),
  :deep(ul) {
    &:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  :deep(ul) > li {
    padding-left: 1.25em;
    position: relative;

    &:before {
      $bulletSize: .5em;

      background: #4a5568;
      border-radius: 100%;
      content: '';
      display: block;
      height: $bulletSize;
      left: 0;
      position: absolute;
      top: calc(($lineHeight - $bulletSize) / 2);
      width: $bulletSize;
    }
  }
}
</style>
